import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=570bca3c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570bca3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570bca3c')) {
      api.createRecord('570bca3c', component.options)
    } else {
      api.reload('570bca3c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=570bca3c&scoped=true", function () {
      api.rerender('570bca3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/service/siteUse/detail.vue"
export default component.exports